import { useContext } from 'react';
import HistoryListContext from './history-list-context';

export default function useHistoryList() {
  return useContext(HistoryListContext);
}
